@for (toast of toasts; track toast; let i = $index) {
  <app-toaster
    [toast]="toast"
    [i]="i"
    (remove)="remove($event)"
  ></app-toaster>
}